module.exports = __webpack_public_path__ + "img/arrow-up-builder-message.02642179.svg";